<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Dedication">This one is for Nancy Etchemendy, blood sister</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SilentStrength-1.vue?c064fd1e